import styled from 'styled-components';
import { MVideoBackgroundButtonPosition } from './MVideoBackground.types';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const OverlayContainer = styled.div<{ buttonPosition: MVideoBackgroundButtonPosition }>`
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  z-index: 1;

  ${({ buttonPosition }) =>
    buttonPosition === MVideoBackgroundButtonPosition.Top
      ? `
    top: 0;
  `
      : `
    bottom: 0;
  `}

  @media (min-width: 768px) {
    padding: 2rem;
  }

  @media (min-width: 992px) {
    padding: 2.5rem;
  }
`;

export default {
  Wrapper,
  VideoContainer,
  OverlayContainer,
};
